import React, { Component } from 'react'
import {
    Container, Row,
    Button, Modal, ModalHeader, ModalBody
} from 'reactstrap'
import './admindescargas.css'
import ItemArchivo from '../../itemArchivo'
import NuevoArchivo from './nuevoArchivo'
import Archivo from '../../utilitarios/archivo'
const archivo = new Archivo

export default class AdminDescargas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            archivo,
            archivos: [],
            modalNuevoArchivo: false
        }
        this.toggle = this.toggle.bind(this)
        this.archivoGuardado = this.archivoGuardado.bind(this)
        this.eliminarArchivo = this.eliminarArchivo.bind(this)
    }

    toggle() {
        this.setState(prevState => ({
            modalNuevoArchivo: !prevState.modalNuevoArchivo
        }));
    }

    archivoGuardado(){
        this.toggle()
        this.leerArchivos()
    }

    eliminarArchivo(e) {
        const _this = this
        let eliminar = window.confirm(`¿Desea eliminar éste archivo? \n ${e.target.name}`)
        if (eliminar) {
            archivo.eliminarFile(e.target.name).then(
                archivo.eliminar(e.target.id).then(_this.leerArchivos())
            )
        }
    }

    leerArchivos(){
        const _this = this
        archivo.getArchivos().then(archivos => {
            _this.setState({
                archivos
            })
        })
    }

    componentWillMount() {
        this.leerArchivos()
    }

    render() {

        return (
            <Container className="DescargasAdmin">
                <h2>Administrador de arhivos</h2>
                <Button onClick={this.toggle} color="dark">Nuevo archivo</Button>
                <Row>
                    {
                        this.state.archivos.map(archivo => <ItemArchivo key={archivo.id} archivo={archivo} admin={true} eliminarArchivo={this.eliminarArchivo} />)
                    }
                </Row>
                <Modal isOpen={this.state.modalNuevoArchivo} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>Nuevo archivo</ModalHeader>
                    <ModalBody>
                        <NuevoArchivo archivoGuardado={this.archivoGuardado} />
                    </ModalBody>
                </Modal>
            </Container>
        )
    }
}